import reduceWithSeparator from '@/helpers/reduce-with-separator'

export default {
  prepareShow (dependent) {
    dependent.covenants = reduceWithSeparator(dependent.active_covenants, 'name')

    return dependent
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/family/resources/methods.js